import { Box, HStack, IconButton, Spacer, Text, VStack } from "@chakra-ui/react"
import { XIcon } from "@pathwright/pathicons"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { Virtuoso } from "react-virtuoso"
import PeopleItem from "./PeopleItem"
import SelectItemRole from "./SelectItemRole"
import { useSelectPeopleContext } from "./SelectPeopleContext"
import SelectRole from "./SelectRole"

const tPrefix = "share_card.add_tab"

const Item = ({ index, item, onClick }) => (
  <HStack
    key={item.meta.key}
    width="100%"
    minW={0}
    justifyContent="space-between"
    pt={1}
    pb={1}
    data-testid={`selected-people-item-${index}`}
  >
    <PeopleItem item={item} showMeta={false} />
    <Box flexShrink={0}>
      <SelectItemRole item={item} />
    </Box>
    <IconButton
      variant="ghost"
      aria-label={`Remove ${item.meta.title}`}
      size="sm"
      flexShrink={0}
      children={<XIcon />}
      onClick={() => onClick(item)}
    />
  </HStack>
)

const List = ({ selected, handleClickItem }) => (
  <Box
    w="100%"
    css={{
      // Fix scroll jank when interacting with an open MenuList near bottom of scroll container.
      "& [data-virtuoso-scroller='true'], & [data-viewport-type='element']": {
        position: "static !important"
      }
    }}
  >
    <Virtuoso
      style={{
        height: "300px",
        width: "100%"
      }}
      totalCount={selected.length}
      itemContent={(index) => (
        <Item index={index} item={selected[index]} onClick={handleClickItem} />
      )}
    />
  </Box>
)

const SelectedPeople = () => {
  const {
    peopleSelection: { selected, queued },
    removeFromPeopleSelection
  } = useSelectPeopleContext()

  const { tc } = useTranslate()

  const handleClickItem = (item) => {
    removeFromPeopleSelection(item)
  }

  if (!selected.length) {
    return (
      <VStack minH="200px" justifyContent="center">
        <Text textStyle="sm" color="gray.400" textAlign="center" mx={5}>
          {tc(
            `${tPrefix}.Type above to add existing members or invite new members by entering an email address.`
          )}
        </Text>
      </VStack>
    )
  }

  return (
    <VStack gap={2} width="100%" alignItems={"flex-end"}>
      <Spacer />
      {!!selected.length && <SelectRole />}
      <VStack gap={6} width="100%">
        <List selected={selected} handleClickItem={handleClickItem} />
      </VStack>
    </VStack>
  )
}

export default SelectedPeople
